import { Injectable } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { CalendarViewCache, WidgetType } from '../../models/calendar-view-cache';

@Injectable()
export class CalendarDataCarrierService {

  constructor() { }
  private calendarView: CalendarViewCache = new CalendarViewCache();
  private _calendarView: ReplaySubject<CalendarViewCache> = new ReplaySubject<CalendarViewCache>();
  private calendarView$ = this._calendarView.asObservable();
  private _todayClicked: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  public todayClicked$ = this._todayClicked.asObservable();


  changeView(view: WidgetType, title?: string, currentDate?: Date) {
    this.calendarView.widget = view;
    if (title) {
      this.calendarView.month_title = title;
    }
    if (currentDate) {
      this.calendarView.current_date = currentDate;
    }
    this._calendarView.next(this.calendarView);
  }

  subscribeCalendarView(): Observable<CalendarViewCache> {
    return this.calendarView$;
  }

  todayCliceked() {
    this._todayClicked.next(true);
  }
}
